import { AppState } from '../store';

export const incomesSelector = (state: AppState) => state.incomesReducer;
